import React, {Component} from "react"
import fetch from "isomorphic-fetch"
import {
  COGOLAND_SESSION_DATE_FORMAT,
  PATH_COGOLAND_PREVIEW_SCHEDULE,
  PATH_RESEND_USER_EMAIL_ADDRESS_CONFIRMATION
} from "../../../constants"
import config from "../../../config"
import {connect} from "react-redux"
import {convertToDisplayFormat, format} from "../../../util/DateUtil"
import moment from "moment"
import BootstrapSingleDatePicker from "../../../components/BootstrapSingleDatePicker"
import WeekdayCheckboxGroup from "./WeekdayCheckboxGroup"
import Form from "../../../components/form/Form"
import {injectIntl} from "react-intl"

function mapStateToProps(state, ownProps) {

  const user = state.user
  return {
    user
  }
}

const mapDispatchToProps = {}

class CreateScheduleForm extends Component {

  constructor(){
    super()
    this.state = {
      dateList : []
    }
  }

  previewSchedule(startDate, schedulableDayOfWeek){

    this.props.onChange({startDate, schedulableDayOfWeek})

    if(startDate && !_.isEmpty(schedulableDayOfWeek)){

      const user = this.props.user

      const token = user.access_token
      const type = user.token_type
      const {api_server_host} = config
      const utcOffset = moment().utcOffset()

      fetch(`${api_server_host}${PATH_COGOLAND_PREVIEW_SCHEDULE}?startDate=${format(startDate)}&schedulableDayOfWeek=${schedulableDayOfWeek}&utcOffset=${utcOffset}`
        , {
          headers: {
            Authorization: `${type} ${token}`
          }
        }).then((response) => {
        return response.json()
      }, (error) => {
        alert(error)
      }).then((json) => {

        this.setState({dateList: json})
      })
    }


  }

  render() {

    const formatMessage = this.props.intl.formatMessage

    return (
      <div>
        <div className="row">
          <div className="col-xs-2 p-sm">{formatMessage({id:'starts.from'})}</div>
          <div className="col-xs-10 p-h-xs">
            <BootstrapSingleDatePicker value={this.state.startDate}
                                       onApply={(e, date)=>{
                                         this.setState({startDate:date})
                                         this.previewSchedule(date, this.state.schedulableDayOfWeek)
                                       }}/>
          </div>

          <Form>
              <WeekdayCheckboxGroup name="schedulableDayOfWeek"
                                    onChange={(name, value)=>{
                                      const schedulableDayOfWeek = _.sortBy(value).join(',')
                                      this.setState({schedulableDayOfWeek})
                                      this.previewSchedule(this.state.startDate, schedulableDayOfWeek)
                                    }}/>
          </Form>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <h4>{formatMessage({id:"schedule.preview"})}</h4>
          </div>
          <div className="col-xs-6">
            <ol>
              {_.take(this.state.dateList, this.state.dateList.length/2).map((d)=><li>{convertToDisplayFormat(d, COGOLAND_SESSION_DATE_FORMAT)}</li>)}
            </ol>
          </div>
          <div className="col-xs-6">
            <ol start={this.state.dateList.length/2+1}>
              {_.takeRight(this.state.dateList, this.state.dateList.length/2).map((d)=><li>{convertToDisplayFormat(d, COGOLAND_SESSION_DATE_FORMAT)}</li>)}
            </ol>
          </div>

        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CreateScheduleForm))



// WEBPACK FOOTER //
// ./src/routes/cogoland/component/CreateScheduleForm.js